export var getPaywallSeoClass = function (_a, blockIndex) {
    var _b = _a.className, className = _b === void 0 ? 'paywall' : _b, _c = _a.index, index = _c === void 0 ? 3 : _c;
    return blockIndex < index && className;
};
export var isPaywallSeo = function (seoMode) {
    return typeof seoMode === 'object' && typeof seoMode.paywall === 'object';
};
//# sourceMappingURL=paywallSeo.js.map